import { useQuery } from '@tanstack/react-query'
import { StorageKey } from '@/client/types'
import { getShopConfig } from '@/infra/services'

/**
 * Get shop config from api. Use staleTime to avoid multiple requests.
 *
 * @param domain
 */
export const useGetShopConfig = (domain: string) =>
  useQuery({
   queryKey: [StorageKey.SHOP_CONFIG, { domain }],
   queryFn: () => getShopConfig(domain),
   staleTime: Infinity,
   refetchOnWindowFocus: false
  })
